import {Component, Input, OnInit} from '@angular/core';
import {FontAwesomeService} from '@services/font-awesome.service';
import {UserService} from '@services/user.service';
import {MatDialog} from '@angular/material';
import {AddCardComponent} from '../add-card/add-card.component';
import {FormGroup} from "@angular/forms";
import {LoadUserCards} from "@store/actions/profile.action";
import {AppState, selectUserCards} from "@store/reducers";
import {Store} from "@ngrx/store";

@Component({
  selector: 'app-payment-settings',
  templateUrl: './payment-settings.component.html',
  styleUrls: ['./payment-settings.component.scss']
})
export class PaymentSettingsComponent implements OnInit {
  cards;
  showForm = false;
  @Input() paymentSettingsForm: FormGroup;

  constructor(
    private userService: UserService,
    public faService: FontAwesomeService,
    public dialog: MatDialog,
    private store: Store<AppState>
  ) {}

  ngOnInit() {
    this.store.dispatch(new LoadUserCards());
    this.store.select(selectUserCards)
      .subscribe(cards => {
        this.cards = cards;
        this.showForm = false;
      });
  }

  setDefaultCards(card) {
    this.userService.setDefaultCards(card.id)
      .subscribe(() => this.store.dispatch(new LoadUserCards()));
  }

  removeCard(card) {
    this.userService.removeCard(card.id).subscribe(() => {
      this.store.dispatch(new LoadUserCards());
    });
  }

  addCard() {
    const dialogRef = this.dialog.open(AddCardComponent, {width: '500px', height: '316px'});
    dialogRef.afterClosed().subscribe(() => {
      this.store.dispatch(new LoadUserCards());
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/user-settings/payment-settings/payment-settings.component.ts